(function closure() {
    'use strict';

    function commonExport(schedule, _, moment) {

        schedule.period = {
            DAY: 'daily',
            WEEK: 'weekly',
            BIWEEK: 'bi-weekly',
            MONTH: 'monthly'
        };

        const subtractDays = function (duration, endDate) {
            // note - 1 because our date ranges are inclusive
            return moment.utc(endDate).subtract(duration.days - 1, 'days');
        };

        const subtractMonths = function (duration, endDate) {
            // note - 1 because our date ranges are inclusive
            return moment.utc(endDate).startOf('month').subtract(duration.months - 1, 'months');
        };

        schedule.durations = [
            {
                id: 'days_1',
                types: [schedule.period.DAY],
                days: 1,
                name: 'Yesterday'
            },
            {
                id: 'days_7',
                types: [schedule.period.DAY],
                days: 7,
                name: 'Last 7 Days'
            },
            {
                id: 'days_14',
                types: [schedule.period.DAY],
                days: 14,
                name: 'Last 14 Days'
            },
            {
                id: 'days_30',
                types: [schedule.period.DAY],
                days: 30,
                name: 'Last 30 Days'
            },
            {
                id: 'days_90',
                types: [schedule.period.DAY],
                days: 90,
                name: 'Last 90 Days'
            },
            {
                id: 'days_180',
                types: [schedule.period.DAY],
                days: 180,
                name: 'Last 180 Days'
            },
            {
                id: 'weeks_1',
                types: [schedule.period.WEEK],
                days: 7,
                name: 'Last Week'
            },
            {
                id: 'weeks_2',
                types: [schedule.period.WEEK, schedule.period.BIWEEK],
                days: 14,
                name: 'Last 2 Weeks'
            },
            {
                id: 'weeks_4',
                types: [schedule.period.WEEK, schedule.period.BIWEEK],
                days: 28,
                name: 'Last 4 Weeks'
            },
            {
                id: 'weeks_12',
                types: [schedule.period.WEEK, schedule.period.BIWEEK],
                days: 84,
                name: 'Last 12 Weeks'
            },

            {
                id: 'months_1',
                types: [schedule.period.MONTH],
                months: 1,
                name: 'Last Month'
            },
            {
                id: 'months_3',
                types: [schedule.period.MONTH],
                months: 3,
                name: 'Last 3 Months'
            }
        ];

        _.each(schedule.durations, function (duration) {
            if (duration.days) {
                duration.fn = _.bind(subtractDays, null, duration);
            } else if (duration.months) {
                duration.fn = _.bind(subtractMonths, null, duration);
            }
        });

        schedule.days = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday'
        ];

        schedule.day = _.reduce(schedule.days, function (obj, day) {
            obj[day.toUpperCase()] = day;
            return obj;
        }, {});

        schedule.periodStart = _.tap({}, function (periodLength) {
            periodLength[schedule.period.DAY] = function (endDate) {
                return moment.utc(endDate);
            };
            periodLength[schedule.period.WEEK] = function (endDate) {
                return moment.utc(endDate).subtract(6, 'days');
            };
            periodLength[schedule.period.BIWEEK] = function (endDate) {
                return moment.utc(endDate).subtract(13, 'days');
            };
            periodLength[schedule.period.MONTH] = function (endDate) {
                return moment.utc(endDate).startOf('month');
            };
        });
    }

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        commonExport(module.exports, require('lodash'), require('../../lib/riq-moment.js'));

    } else {

        RivalIQ.module('enums.schedule', function (schedule, App, Backbone, Marionette, $, _, moment) {
            commonExport(schedule, _, moment);
        }, window.moment);
    }

})();
